var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrikeThrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1601_1244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 12.553 23.552 13 23 13H1C0.448 13 0 12.553 0 12C0 11.447 0.448 11 1 11H5.081C3.218 9.997 2 8.03 2 5.849C2 2.624 4.624 0 7.848 0H16.083C19.345 0 22 2.654 22 5.917V7C22 7.553 21.552 8 21 8C20.448 8 20 7.553 20 7V5.917C20 3.757 18.243 2 16.083 2H7.848C5.726 2 4 3.727 4 5.849C4 7.581 5.167 9.109 6.84 9.563L12.133 11.001H23C23.552 11.001 24 11.448 24 12.001V12ZM20.057 15.11C19.562 15.354 19.359 15.954 19.603 16.45C19.862 16.974 19.999 17.563 19.999 18.151C19.999 20.273 18.273 22 16.151 22H7.917C5.757 22 4 20.243 4 18.083V17C4 16.447 3.552 16 3 16C2.448 16 2 16.447 2 17V18.083C2 21.346 4.654 24 7.917 24H16.152C19.377 24 22 21.376 22 18.151C22 17.257 21.792 16.363 21.396 15.563C21.151 15.069 20.552 14.864 20.057 15.11Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1601_1244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikeThrough);
export default __webpack_public_path__ + "static/media/strike-through.71892ee3dd082ea2590767938c864ebc.svg";
export { ForwardRef as ReactComponent };